<template>
    <div id="footer-template" class="footer">
        <div class="row justify-content-center text-center">   
             <div class="col-sm-1">
                <a href="mailto:0xbattleblocks@gmail.com?Subject=Hello" target="_top">
                    {{ 'CONTACT' | translate }}
                </a>
            </div>
            <div class="col-sm-1">
                <a href="javascript:void(0)" @click="openModal">
                    {{ 'ABOUT_AND_RULES' | translate }}
                </a>
            </div>  
            <div class="col-sm-1">
                <router-link to="/leaderboard">
                    {{ 'LEADERBOARDS' | translate }}
                </router-link>
            </div>       
            <div class="col-sm-1">
                <div class="donation-address">
                    <a href="https://explorer.nebulas.io/#/address/n1xk11Wm6zboVgKiyUJwiNcfDycYjkm4K4v" target="_blank">
                        {{ 'FOOTER.CONTRACT' | translate }}
                    </a>
                </div>
            </div>
        </div>
        <div class="copyright">
            {{ 'MAIN_BRAND_NAME' | translate }} &copy; {{ thisYear }}
        </div>
    </div>
</template>

<script type="text/javascript">
  export default {
    name: 'footer-template',
    computed: {
        thisYear () {
          return new Date().getFullYear();
        }
    },
    methods: {
      openModal () {
           this.$root.$emit('bv::show::modal','modal-about');
      }
    }
  }
</script>

<style scoped lang="less">

@accentColor: #88929B;

.footer {
  // border-top: 1px solid #88929B;
  background: #212432;
  padding-top: 30px;
  color: @accentColor;
  font-size: 14px;
  overflow: hidden;

  header {
    color: @accentColor;
    font-weight: bold;
    margin-bottom: 5px;
  }

  a {
    color: @accentColor;
  }

  .fab {
    font-size: 28px;
    margin-right: 10px;
  }

  .horizontal-list {
    list-style: none;
    padding: 0;
  }

  .donation-address {
    font-size: 14px;
    margin-bottom: 20px;
  }

  .copyright {
    font-size: 10px;
    text-align: center;
    margin-top: 10px;
    padding: 10px 0 40px;
    // border-top: 1px solid @accentColor;
  }
}

@media only screen and (max-width: 600px) {
  .footer { 
    .col-sm-3 {
      padding: 0 30px;
    }
    .donation-address {
      font-size: 12px!important;
    }
  }  
}
</style>



// WEBPACK FOOTER //
// src/components/layout/TheFooter.vue